import PropTypes from 'prop-types';
import React from 'react';
import {withMetrics} from '../../metrics';
import {OCCSideBar} from '../../organisms';
import SystemOverviewSideBar from '../../organisms/SystemOverviewSideBar';
import SystemsList from '../../organisms/SystemsList';
import WithSlidingRightSideBar from '../../templates/WithSlidingRightSideBar';

class HomePage extends React.Component {
  state = {
    selected: {},
    hasSelected: false,
  };

  onSelect = selected => this.setState({selected, hasSelected: true});

  onSideBarCollapse = () => this.setState({selected: {}, hasSelected: false});

  SystemsOverview = ({systems}) => (
    <SystemsList
      systems={systems}
      onSelect={this.onSelect}
      selected={this.state.selected}
      loading={this.props.loading}
    />
  );

  SystemPreview = () => (
    <SystemOverviewSideBar
      selected={this.state.selected}
      onCollapse={this.onSideBarCollapse}
    />
  );

  render() {
    const {systems} = this.props;
    return (
      <WithSlidingRightSideBar
        NavBar={OCCSideBar}
        RightSideBar={this.SystemPreview}
        navBarWidth={60}
        open={this.state.hasSelected}
      >
        <SystemsList
          systems={systems}
          onSelect={this.onSelect}
          selected={this.state.selected}
          loading={this.props.loading}
        />
      </WithSlidingRightSideBar>
    );
  }
}

HomePage.propTypes = {
  loading: PropTypes.bool,
  systems: PropTypes.array,
};

export default withMetrics(HomePage, 'HomePage');
